import { render } from "./Login.vue?vue&type=template&id=2b2f898e"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render

export default script